import { useCustomerShowApi } from '@entities/customer'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  void useCustomerShowApi({ customerId })
})